/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */

import React from 'react';
import './footer.scss';

export default ({ ...rest }) => <footer className={'footer'} {...rest} />;
